import { SaveEnumDynamicAttribute } from "@/modules/dynamic-attributes/feature/save-enum-dynamic-attribute";
import { useSelectedGroupId } from "../model/selected-group/use-selected-group-id";
import { useEditorConfig } from "../model/config/use-config";
import { useEntityAttributeById } from "../model/entity-attributes/use-entity-attribute-by-id";
import { extractLocalizedValue } from "@/shared/form/localized-value/utils/extract-localized-value";

export function EditEnumAttribute({
  attributeId,
  afterSubmit,
}: {
  attributeId: string;
  afterSubmit?: () => void;
}) {
  const { entity, category } = useEditorConfig();
  const groupId = useSelectedGroupId();

  const attribute = useEntityAttributeById(attributeId);

  if (attribute?.__typename !== "EnumTypeDynamicAttributeDto") {
    return null;
  }

  return (
    <SaveEnumDynamicAttribute
      afterSubmit={afterSubmit}
      groupId={groupId}
      dynamicAttributeEntity={entity}
      initialValues={{
        id: attributeId,
        group: groupId,
        dynamicAttributeEntity: entity,
        description: extractLocalizedValue(attribute.description),
        name: extractLocalizedValue(attribute.name),
        attributeCode: attribute.attributeCode,
        order: attribute.order,
        enum: attribute.enumId as string,
        category,
      }}
    />
  );
}
